<template>
  <v-row>
    <v-col>
      <ApplicationRouteList />
    </v-col>
  </v-row>
</template>

<script>
  import ApplicationRouteList from "@/components/config/medicine/application_route/list.vue";

  export default {
    name: "ApplicationRouteConfig",
    components: {
      ApplicationRouteList,
    },
  };
</script>

<style lang="scss" scoped></style>
